import { render, staticRenderFns } from "./AuthorizeProject.vue?vue&type=template&id=517b8044&"
import script from "./AuthorizeProject.vue?vue&type=script&lang=js&"
export * from "./AuthorizeProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports